import { render } from "./ThemeButton.vue?vue&type=template&id=087d4c2e&scoped=true"
import script from "./ThemeButton.vue?vue&type=script&lang=js"
export * from "./ThemeButton.vue?vue&type=script&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=087d4c2e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087d4c2e"]])

export default __exports__